/* eslint-disable linebreak-style */
import { useEffect, useState, useContext } from 'react';
import UserAgentContext from 'root/utils/withUA/UserAgentContext';
import { useAmp } from 'next/amp';

const MobileDetect = require('mobile-detect');

const isTest = process.env.NODE_ENV === 'test';

const getDevices = (ua) => {
  if (!ua) {
    return {
      isPhone: false,
      isTablet: false,
      isDesktop: false
    };
  }
  const md = new MobileDetect(ua);
  return {
    isPhone: !!md.phone(),
    isTablet: !!md.tablet(),
    isDesktop: !md.phone() && !md.tablet()
  };
};

const useDeviceScreen = (phone = 425, desktop = 1024) => {
  const ua = useContext(UserAgentContext);
  const [width, setWidth] = useState(false);
  const devices = getDevices(ua);
  const isAmp = useAmp();
  useEffect(() => {
    if (!window) return width;

    if (!width) {
      setWidth(window.innerWidth);
    }

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [width]);

  if (isAmp) {
    return { width, isPhone: true, isTablet: false, isDesktop: false, isMobile: true };
  }

  return {
    width,
    isPhone: !isTest && width ? width <= phone : devices.isPhone,
    isTablet: !isTest && width ? width > phone && width < desktop : devices.isTablet,
    isDesktop: !isTest && width ? width >= desktop : devices.isDesktop,
    isMobile: !isTest && width ? width <= phone || (width > phone && width < desktop) : devices.isPhone || devices.isTablet
  };
};

export default useDeviceScreen;
